import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import * as moment from 'moment';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';


@Injectable()
export class PurchaseOrderService {

  constructor(
    private authHttp: HttpClient,
    public currentUserService: CurrentUserService,
    private _gaSvc: GoogleAnalyticsService,
    private errorHandlerService: ErrorHandlerService,
    private flashMessageService: FlashMessageService,
    handler: HttpBackend
  ) { this.httpClient = new HttpClient(handler); }

  private httpClient: HttpClient;
  public showFilter: boolean = false;
  private purchaseOrdersUrl = environment.runtime.userManagementApiUrl;
  private purchaseOrderApiUrl = environment.runtime.userManagementApiUrl;
  private customerApiUrl = environment.runtime.userManagementApiUrl;
  private supplierApiUrl = environment.runtime.userManagementApiUrl;
  private locationApiUrl = environment.runtime.userManagementApiUrl;
  public worklistCount: number = 0;
  public domainName: string;
  public appliedFilterCount: number = 0;
  public activeFilters = [];
  public showRelease: boolean = false;
  public qSearch: String = '';
  public query = {
    regexString: '',
    supplierName: '',
    weight: {
      weight: null,
      weightType: null,
      operator: null
    },
    volume: {
      volume: null,
      volumeType: null,
      operator: null
    },
    deliveryDate: {
      dateType: null,
      input1: null,
      input2: null
    },
    destination: {
      city: null,
      state: null,
      zipCode: null
    },
  };

  token = "796f5a5a-74e9-4b45-a770-4504ed6ee2bb";

  // shipWindowClosedDate = delivery date - transitTime
  public getClosingShipWindow(deliveryDateStr: string, transitTime: number = 0): string {
    return (deliveryDateStr) ? moment(deliveryDateStr).subtract(transitTime || 0, 'days').utc().format() : '';
  }



  public getOrders(status: String, query: number): Promise<any> {
    let url = `${this.purchaseOrdersUrl}/getPurchaseOrdersummary/${status}`;
    if (query) {
      url = `${this.purchaseOrdersUrl}/getPurchaseOrdersummary/${status}?skip=${query}`;
    }
    return this.authHttp.get(url)
      .toPromise()
      .then((purchaseOrders) => {
        return purchaseOrders;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public getFilteredOrders(status: String, skip: number): Promise<any> {
    let body = this.query;
    Object.assign(body, { purchaseOrderStatus: status, skip: skip, limit: 1000 });
    return this.authHttp.post(`${this.purchaseOrdersUrl}/getPurchaseOrderFilteredSummary`, body)
      .toPromise()
      .then((data: any) => {
        return data.purchaseOrders;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public getLineDetails(id) {
    return this.authHttp.get(`${this.purchaseOrderApiUrl}/LineDetail/${id}`)
      .toPromise()
      .then((detail: any) => {
        return detail;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public sendGA(page) {
    if (this.currentUserService.user != null) {
      this._gaSvc.register('Purchase Orders', 'User viewed ' + page + ' page', this.currentUserService.user.organizationName);
    } else {
      this.currentUserService.getUser().then(() => {
        this._gaSvc.register('Purchase Orders', 'User viewed ' + page + ' page', this.currentUserService.user.organizationName);
      })
    }
  }

  public getPurchaseOrderCount(id = null, type = 'customer'): Promise<any> {
    let url = '';
    switch (type) {
      case 'customer':
        url = `${this.purchaseOrderApiUrl}/purchaseOrder/customer/count`
        break;
      case 'supplier':
        url = `${this.purchaseOrderApiUrl}/purchaseOrder/count`
        break;
    }
    if (id)
      url += `/${id}`;
    return this.authHttp.get(url)
      .toPromise()
      .then((purchaseOrderCount: any) => {
        return purchaseOrderCount;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  };

  public releasePO(data, purchaseOrderLineId): Promise<any> {
    data.purchaseOrderLineId = purchaseOrderLineId;
    return this.authHttp.post(`${this.purchaseOrderApiUrl}/releasePO`, data)
      .toPromise()
      .then((releaseData) => {
        this.flashMessageService.updateMessage('succesfully released order', 4000, 'success');
        return;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public getRequiredFields(customerId): Promise<any> {
    return this.authHttp.get(`${this.customerApiUrl}/supplier_release_requirements/${customerId}`)
      .toPromise()
      .then((prefrences: any) => {
        return prefrences;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message || "there was an error retriving your preferences");
      });
  }

  public getLocations(destinationId): Promise<any> {
    return this.authHttp.get(`${this.locationApiUrl}/${destinationId}`)
      .toPromise()
      .then((locationDetail: any) => {
        return locationDetail;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public getSupplierLocations(supplierId, city = '', state = ''): Promise<any> {
    return this.authHttp.get(`${this.supplierApiUrl}/supplier/${supplierId}`)
      .toPromise()
      .then((locationDetail: any) => {
        return this.filterSupplierLocation(locationDetail.locations, city, state);
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  private filterSupplierLocation(locations: any[] = [], city: string, state: string ): any[] {
    if ((!city && !state) || !locations || !locations.length) return locations;

    const filter = (location) => {
      if (city && state) {
        return location.city.toUpperCase() === city.toUpperCase() && location.state.toUpperCase() === state.toUpperCase();
      } else if (!city && state) {
        return location.state.toUpperCase() === state.toUpperCase();
      } else {
        return location.city.toUpperCase() === city.toUpperCase();
      }
    };

    return locations.filter(filter);
  }

  public updatePO(po, data): Promise<any> {
    let holderData = [];
    po.forEach((element) => {
      let temp = {};
      Object.assign(temp, { id: element });
      Object.assign(temp, data);
      holderData.push(temp);
    });
    return this.authHttp.post(`${this.purchaseOrderApiUrl}/mass-update`, holderData)
      .toPromise()
      .then(() => {
        return;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public saveRelease(releaseInfo, poId): Promise<any> {
    Object.assign(releaseInfo, { id: poId });
    let body = [];
    body.push(releaseInfo);
    return this.authHttp.post(`${this.purchaseOrderApiUrl}/mass-update`, body)
      .toPromise()
      .then(() => {
        return;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public getSavedInfo(id): Promise<any> {
    return this.authHttp.get(`${this.purchaseOrderApiUrl}/mass-update/${id}`)
      .toPromise()
      .then((savedFields: any) => {
        return savedFields;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public quickSearch(id, status) {
    let body = this.query;
    body.regexString = id;
    Object.assign(body, { purchaseOrderStatus: status });
    return this.authHttp.post(`${this.purchaseOrdersUrl}/getPurchaseOrderFilteredSummary`, body);
  }

  public destinationLookup(destination): Promise<any> {
    return this.authHttp.post(`${this.purchaseOrderApiUrl}/destinationLookup`, { destination: destination })
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public getAddress(query: string, countryCode: string): any {
    query = query.trim();
    if (query.length < 3)
      return Promise.resolve([]);
    return this.authHttp.get(`${this.locationApiUrl}/experian/search?query=${query}&country=${countryCode}`)
      .toPromise()
      .then((locationDetail: any) => {
        return locationDetail;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public addLocation(form, supplierID) {
    delete form.Address;
    delete form.Override;
    return this.authHttp.post(`${this.locationApiUrl}/${supplierID}`, form).toPromise()
      .then((location: any) => {
        return location;
      })
      .catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  };

  public getXrefOrders(filter): Promise<any> {
    return this.authHttp.get(`${this.purchaseOrderApiUrl}/xref/${filter}`)
      .toPromise()
      .then((xref: any) => {
        return xref;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  public getXrefRelatedOrders(customerID, supplierID): Promise<any> {
    return this.authHttp.get(`${this.purchaseOrderApiUrl}/xref-related-purchase-orders?customerID=${customerID}&supplierID=${supplierID}`)
      .toPromise()
      .then((relatedOrders: any) => {
        return relatedOrders;
      }).catch(e => {
        return this.errorHandlerService.handleError(e, e.message);
      });
  }

  linkSupplier(customerSupplierID, customerID, supplierID, supplierName) {
    return this.authHttp.post(`${this.purchaseOrderApiUrl}/xref`, { custSupID: customerSupplierID, custID: customerID, suppID: supplierID, suppName: supplierName })
      .toPromise()
      .then((response: any) => response)
      .catch(e => this.errorHandlerService.handleError(e, e.message));
  }


   /**
   * Requests api for Purchase Orders with given filter parameters
   * @param filterBody
   * @return promise of filtered PurchaseOrders
   */
  public getFilteredPurchaseOrders(filterBody: any, endpoint: string = '/purchaseOrderS/filter'): Promise<any> {
    return this.authHttp.post(`${this.purchaseOrderApiUrl}${endpoint}`, filterBody).toPromise();
  }
}
